import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import RoundedContentBox from "@/components/general/roundedContentBox";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";
import styles from "@/components/general/missingPagePermission.module.css";

interface MissingPagePermissionProps {
  permissionRequired: string;
}

const MissingPagePermission: FC<MissingPagePermissionProps> = ({
  permissionRequired,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  usePageHeading(t("missing_page_permission_heading"));

  return (
    <RoundedContentBox className={styles.container}>
      <LockOutlinedIcon className={styles.icon} />
      <p className={styles.text}>{t("missing_page_permission_text")}</p>
      <p className={styles.requestHint}>
        {t("missing_page_permission_request_hint", {
          permission: permissionRequired,
        })}
      </p>
      <GenericButton onClick={() => navigate("/")}>
        {t("back_to_start_page")}
      </GenericButton>
    </RoundedContentBox>
  );
};

export default MissingPagePermission;
